import React, { Component } from "react";
import sanitizeHtml from "sanitize-html";

class ContentDiv extends Component {
	render() {
		return (
			<div
				className={this.props.className}
				dangerouslySetInnerHTML={{
					__html: sanitizeHtml(this.props.children, {
						allowedTags: sanitizeHtml.defaults.allowedTags.concat(["h1", "h2"])
					})
				}}
			/>
		);
	}
}

export default ContentDiv;



// WEBPACK FOOTER //
// ./src/components/utils/ContentDiv.js